import React from 'react';
import { useNavigate } from 'react-router-dom';
import { GlassCard } from '../../components';
import './AboutScreen.css';

export const AboutScreen = () => {
    const navigate = useNavigate();

    const features = [
        { icon: 'trending_up', title: 'Daily Income', desc: 'Earn daily returns on your investments' },
        { icon: 'security', title: 'Secure', desc: 'Your funds are safe and protected' },
        { icon: 'support_agent', title: '24/7 Support', desc: 'Always here to help you' },
        { icon: 'speed', title: 'Fast Withdrawals', desc: 'Quick processing of withdrawals' },
    ];

    const legalLinks = [
        { title: 'Terms of Service', route: '/terms' },
        { title: 'Privacy Policy', route: '/privacy' },
        { title: 'Refund Policy', route: '/refund' },
    ];

    return (
        <div className="about-screen">
            <div className="screen-header">
                <button className="back-btn" onClick={() => navigate(-1)}>
                    <span className="material-icons">arrow_back</span>
                </button>
                <h1 className="screen-title">About</h1>
                <div style={{ width: 40 }}></div>
            </div>

            <div className="app-info">
                <div className="app-logo">
                    <img src="/assets/images/logo.png" alt="Yonex AI Logo" className="app-logo-image" />
                </div>
                <h2 className="app-name">Yonex AI</h2>
                <span className="app-version">Version 1.0.0</span>
                <p className="app-description">
                    Yonex AI ek modern software company hai jo smart, secure aur scalable digital products banane par focus karti hai. Hum web applications, admin panels, automation systems aur data-driven platforms develop karte hain jo businesses ko fast grow karne me help karte hain.
                </p>
            </div>

            <GlassCard className="features-card">
                <h3>Why Choose Us?</h3>
                <div className="features-grid">
                    {features.map((feature, index) => (
                        <div key={index} className="feature-item">
                            <span className="material-icons feature-icon">{feature.icon}</span>
                            <div className="feature-content">
                                <span className="feature-title">{feature.title}</span>
                                <span className="feature-desc">{feature.desc}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </GlassCard>

            <div className="legal-section">
                <h3>Legal</h3>
                <div className="legal-links">
                    {legalLinks.map((link, index) => (
                        <GlassCard
                            key={index}
                            className="legal-link"
                            onClick={() => navigate(link.route)}
                        >
                            <span>{link.title}</span>
                            <span className="material-icons">chevron_right</span>
                        </GlassCard>
                    ))}
                </div>
            </div>

            <div className="copyright">
                <p>© 2026 Yonex AI. All rights reserved.</p>
                <p>Made with ❤️ in India</p>
            </div>
        </div>
    );
};

export default AboutScreen;
